import { useState, useRef, useEffect } from "react";

import * as Material from "@mui/material";

import "./styles.scss";
import { useCommunity } from "contexts/community";

import { UserAvatar } from "@components/Community";

import Feed from "@components/Feed";

import { Button } from "@fragments";

import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import DynamicFeedIcon from "@mui/icons-material/DynamicFeed";

import api from "@helpers/api";
import Carousel from "react-multi-carousel";
import { AddRounded } from "@material-ui/icons";
import PublishPostModal from "@components/Modals/PublishPost";

import { useAuth } from '@contexts/AuthContext'
import { LandscapeRounded } from "@mui/icons-material";



export default function Group({ community, triggerEdit }) {
    const { community: management, loadCommunities } = useCommunity();
    const { user } = useAuth();

    const REF_createPostModal = useRef();


    const [group, setGroup] = useState(
        community.groups?.length ? community.groups[0].id : null
    );

    const [groupInfo, setGroupInfo] = useState(null);
    const [loadingGroupInfo, setLoadingGroupInfo] = useState(false);

    useEffect(() => {
        if (group) {
            handleLoadGroupInfo();
        } else {
            setGroupInfo(null);
        }
    }, [group]);

    async function handleLoadGroupInfo() {
        if (!group) return;

        setLoadingGroupInfo(true);

        try {
            const { data } = await api.get("community/group/" + group);

            setGroupInfo(data);
        } catch (e) {
            console.log(e);
            setGroupInfo(null);
        }

        setLoadingGroupInfo(false);
    }

    function FeedRender() {
        if (!management?.hasAccessToGroup(community.id, group)) {
            return (
                <>
                    <h3 className="bold pr-2">Você não tem acesso a este grupo</h3>
                </>
            );
        }

        return (
            <div className="feed-group">
                <Feed key={group} fluidMode={true} groupId={group} />
            </div>
        );
    }


    function CreatePostButton() {
        function handleCreatePost() {
            REF_createPostModal.current.open(
                { group: group },
                (result) => {
                    if (result?.gamification) {
                        const { points } = result.gamification;
                        if (points.post || points.activity) {
                            window.setSnackbar(`Você ganhou ${points.post + points.activity} pontos`)
                        }
                    }
                    loadCommunities()
                }
            );
        }

        return (
            <div className="add-post-button mb-4 mt-3" onClick={handleCreatePost}>
                <div className="add-post-user">
                    <UserAvatar user={user} size={32} />
                    <h4 className="bold">Compartilhar nova publicação</h4>
                </div>
                <div className="add-post-buttons">
                    <LandscapeRounded />
                    <AddRounded className="add-btn-post" />
                </div>
            </div>
        )
    }

    function Ranking() {
        const [loading, setLoading] = useState(false);

        const REF_ranking = useRef([]);

        useEffect(() => {
            handleLoadRanking();
        }, [group]);

        async function handleLoadRanking() {
            setLoading(true);

            try {
                const { data } = await api.get("community/ranking?page=0&limit=15&group_id=" + group)
                REF_ranking.current = { ...data };
            } catch (e) {
                console.log(e);
            }

            setLoading(false);
        }


        function UserInRanking({ item }) {
            return (
                <div className="user-in-ranking bsf-9">
                    <span className="ranking-position">#{(item.position > 9 ? '' : '0') + (item.position + 1)}</span>
                    <UserAvatar size={38} user={item} />
                    <span className="bold ranking-username">{item.username}</span>
                    <small className="ranking-points" style={{ opacity: 0.6 }}>{item.points} pontos</small>
                </div>
            )
        }

        return (
            <div className='ranking mt-3 mb-5' >
                <h4 className="bold">Ranking do desafio • <span>Sua posição: #{REF_ranking.current?.currentUser?.position || '-'}</span></h4>

                <div className="ranking-list mt-1" key={loading}>
                    {
                        REF_ranking.current?.ranking && REF_ranking.current.ranking.length > 0 ? (
                            <Carousel
                                responsive={{
                                    desktop: {
                                        breakpoint: { max: 3000, min: 1024 },
                                        items: 4,
                                        partialVisbile: true
                                    },
                                    tablet: {
                                        breakpoint: { max: 1024, min: 464 },
                                        items: 3,
                                        partialVisbile: true
                                    },
                                    mobile: {
                                        breakpoint: { max: 464, min: 0 },
                                        items: 2,
                                        partialVisbile: true
                                    }
                                }}
                                swipeable={true}
                                draggable={true}
                                showDots={false}
                                infinite={false}
                                keyBoardControl={true}
                                centerMode={false}
                                itemClass="carousel-item-padding-40-px"
                            >
                                {
                                    REF_ranking.current.ranking.map((item, index) => (
                                        <div key={index} style={{ marginRight: '2px' }}>
                                            <UserInRanking item={item} />
                                        </div>
                                    ))
                                }
                            </Carousel>
                        ) : (
                            <div className="text-center" style={{ padding: '20px', opacity: 0.6 }}>
                                Nenhum ranking disponível
                            </div>
                        )
                    }
                </div>
            </div>
        )
    }

    return (
        <>
            <div className="group">
                <div className="header mb-1 screen-padding mt-2 csf-2">
                    <DynamicFeedIcon className="" />
                    <h3 className="bold pr-2">Feed do grupo</h3>
                </div>

                <div className="groups-tab border-sf-3 mb-4">
                    <div className="screen-padding" style={{ display: "flex", alignItems: "center" }}>
                        {community.isAdmin() && (
                            <Button
                                tooltip="Adicionar novo grupo"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    triggerEdit()
                                }}
                                icon={<AddRoundedIcon />}
                                color="overlay"
                            />
                        )}
                        <Material.Tabs
                            value={group || false}
                            onChange={(event, newValue) => setGroup(newValue)}
                            variant="scrollable"
                            className="groups-tabs"
                        >
                            {community.groups?.length > 0 ? (
                                community.groups.map((groupItem) => (
                                    <Material.Tab
                                        key={groupItem.id}
                                        label={
                                            <div className="group-select-input">
                                                {
                                                    groupItem.banner
                                                        ? <img src={groupItem.banner} className="group-banner" />
                                                        : <div className="group-banner" />
                                                }
                                                <h4 style={{ margin: 0 }} className="mr-1">
                                                    {groupItem.name}
                                                </h4>
                                                {community.isAdmin() && group && (
                                                    <Button
                                                        tooltip="Configurar grupo"
                                                        icon={<SettingsRoundedIcon />}
                                                        color="overlay"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            triggerEdit(community.groups.filter((g) => g.id === group)[0])

                                                        }}
                                                        style={{ marginLeft: '-8px !important' }}
                                                    />
                                                )}
                                            </div>
                                        }
                                        value={groupItem.id}
                                        className={`${group === groupItem.id ? 'current-tab' : ''} `}
                                    />
                                ))
                            ) : (
                                <Material.Tab
                                    label={
                                        <h4 style={{ margin: 0 }}>
                                            <i>Nenhum grupo</i>
                                        </h4>
                                    }
                                    value={false}
                                    disabled={true}
                                />
                            )}
                        </Material.Tabs>
                    </div>
                </div>

                {
                    groupInfo?.type === 'CHALLENGE' && <div className="screen-padding"><Ranking /></div>
                }

                {
                    groupInfo?.interactions_enabled && (
                        <CreatePostButton />
                    )
                }

                {group && <FeedRender />}
            </div>

            <PublishPostModal modalRef={REF_createPostModal} />
        </>
    );
}